import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { TrackerService } from '../../../../../services/tracker.service';

@Component({
  selector: 'tracker-admin-workflow-transition-tab-scripts',
  template: require('./tracker.workflow.transition.tab.scripts.component.html'),
})
export class TrackerAdminWorkflowTransitionTabScriptsComponent implements OnInit {
  @Input() toFieldElement: any;
  @Input() tracker: any;

  trackerTransitionScripts: any[] = [];
  trackerTransitionScriptsLabel: string = '';

  constructor(private trackerService: TrackerService) {}

  ngOnInit() {
    this.trackerTransitionScripts = _.get(this.tracker, 'rel.transition_scripts', []);
    this.setTrackerTransitionScriptsLabel();
  }

  setTransitionScript(script: any) {
    const isScriptEnabled = _.find(this.toFieldElement.enabledTransitionScripts, (enabledScript: any) => enabledScript.id === script.id);

    if (isScriptEnabled) {
      _.remove(this.toFieldElement.enabledTransitionScripts, (enabledScript: any) => enabledScript.id === script.id);
    } else {
      if (script.id === 0) this.toFieldElement.enabledTransitionScripts = [];
      if (!this.toFieldElement.enabledTransitionScripts) this.toFieldElement.enabledTransitionScripts = [];
      this.toFieldElement.enabledTransitionScripts.push({ id: script.id, description: script.description });
    }

    this.trackerService.fields.removeNone(this.toFieldElement.enabledTransitionScripts, true);
    this.setTrackerTransitionScriptsLabel();
  }

  isTransitionScriptSelected(script: any): boolean {
    return _.some(this.toFieldElement.enabledTransitionScripts, { id: script.id });
  }

  private setTrackerTransitionScriptsLabel() {
    this.trackerTransitionScriptsLabel = _.map(this.toFieldElement.enabledTransitionScripts, 'description').join(', ');

    if (this.trackerTransitionScriptsLabel === '') this.trackerTransitionScriptsLabel = 'None';
  }
}
